import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoPhotographyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_photography"}/>
}
